import { Download } from "lucide-react";
import { downloadJson } from "./data";

const TONES = {
    green: "bg-green-50 text-green-700 border-green-200",
    amber: "bg-amber-50 text-amber-700 border-amber-200",
    red: "bg-red-50 text-red-700 border-red-200",
    blue: "bg-blue-50 text-blue-900 border-blue-200",
    slate: "bg-slate-100 text-slate-600 border-slate-200",
};

export const StatusChip = ({ tone = "slate", children, testId }) => (
    <span
        data-testid={testId}
        className={`inline-flex items-center rounded-sm border px-2 py-0.5 font-mono text-[11px] uppercase tracking-wide ${TONES[tone] || TONES.slate}`}
    >
        {children}
    </span>
);

export const Kicker = ({ children }) => (
    <p className="font-mono text-xs uppercase tracking-[0.14em] text-slate-400">{children}</p>
);

export const DownloadReceiptBtn = ({ json, filename, testId, label = "Download synthetic JSON" }) => (
    <button
        onClick={() => downloadJson(json, filename)}
        data-testid={testId}
        className="inline-flex items-center gap-1.5 rounded-sm border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 transition-colors duration-150 hover:bg-slate-50"
    >
        <Download className="h-3.5 w-3.5" strokeWidth={1.5} />
        {label}
    </button>
);

export const LocalBoundary = ({ children, highlight, dim, testId }) => (
    <div
        data-testid={testId}
        className={`relative rounded-sm border-2 border-dashed p-4 transition-opacity duration-300 ${
            highlight ? "border-blue-900" : "border-slate-300"
        } ${dim ? "opacity-40" : "opacity-100"}`}
    >
        <span className="absolute -top-2 left-3 bg-slate-50 px-1.5 font-mono text-[9px] uppercase tracking-[0.14em] text-slate-400">
            Local custody boundary
        </span>
        {children}
    </div>
);

export const ChainRow = ({ steps, activeIndex, testIdPrefix }) => (
    <div className="flex flex-wrap items-center gap-2">
        {steps.map((s, i) => (
            <span key={s} className="flex items-center gap-2">
                <StatusChip
                    tone={i <= activeIndex ? "blue" : "slate"}
                    testId={`${testIdPrefix}-step-${i}`}
                >
                    {s}
                </StatusChip>
                {i < steps.length - 1 && <span className="text-slate-300">→</span>}
            </span>
        ))}
    </div>
);
